module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    staticClass: "edit-member-dialog",
    attrs: {
      "title": "编辑成员信息",
      "size": "small",
      "visible": _vm.dialogVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "label-position": "top"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "姓名"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 17
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "成员姓名",
      "disabled": ""
    },
    model: {
      value: (_vm.name),
      callback: function($$v) {
        _vm.name = $$v
      },
      expression: "name"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6,
      "offset": 1
    }
  }, [_c('el-select', {
    attrs: {
      "disabled": _vm.role === 'owner'
    },
    model: {
      value: (_vm.role),
      callback: function($$v) {
        _vm.role = $$v
      },
      expression: "role"
    }
  }, _vm._l((_vm.roles), function(item) {
    return _c('el-option', {
      key: item,
      attrs: {
        "label": _vm.$t(("organization.roles." + item)),
        "value": item,
        "disabled": item === 'owner'
      }
    })
  }))], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "邮箱地址"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "邮箱地址",
      "disabled": ""
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "所属部门"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.department),
      callback: function($$v) {
        _vm.department = $$v
      },
      expression: "department"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v(_vm._s(_vm.$t('common.buttons.cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v(_vm._s(_vm.$t('common.buttons.ok')))])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2633ffe4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/members/details/edit_member.dialog.vue
// module id = 904
// module chunks = 3